import { useCallback, useState } from 'react';
import { LayoutChangeEvent, useWindowDimensions } from 'react-native';

/**
 * Keyboard offset for a KeyboardAvoidingView inside a sheet.
 * The sheet starts below the top of the window, so the gap above it is the offset.
 * On full screens there's no gap, so it's 0.
 */
export const useSheetKeyboardOffset = () => {
    const { height: windowHeight } = useWindowDimensions();
    const [keyboardVerticalOffset, setKeyboardVerticalOffset] = useState(0);

    // a sheet always reaches the bottom of the window, so what's left above it is the offset
    const onLayout = useCallback(
        ({ nativeEvent: { layout } }: LayoutChangeEvent) => {
            setKeyboardVerticalOffset(Math.max(windowHeight - layout.y - layout.height, 0));
        },
        [windowHeight]
    );

    return { keyboardVerticalOffset, onLayout };
};
